import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import { FunctionComponent, useContext, useEffect, useState } from 'react';
import {
  getDepartmentByMunicipality,
  getMunicipalityName,
  splitField,
  splitFieldForms,
} from '../shared/utils';
import styles from '../styles/components/start-finish-view.module.scss';
import Icon from './base/icon';
import { GeneralConfigContext } from './general-config-provider';

type StartFinishViewProps = {
  points: any;
};

export const StartFinishView: FunctionComponent<StartFinishViewProps> = ({
  points,
}) => {
  const { generalConfig } = useContext(GeneralConfigContext);
  const t = useTranslations('viewOffer');
  const router = useRouter();
  const [locale, setLocale] = useState(router?.locale);
  const [showStartInfo, setShowStartInfo] = useState(false);
  const [showEndInfo, setShowEndInfo] = useState(false);

  const toggleStepStatus = (event, step: string) => {
    event.preventDefault();
    if (step === 'start') setShowStartInfo(!showStartInfo);
    if (step === 'end') setShowEndInfo(!showEndInfo);
  };

  useEffect(() => {
    if(router.locale) {
      setLocale(router?.locale)
    }
  }, [router?.locale])
  return (
    <div className={styles.startFinishView}>
      {points[1].id_municipio && (
        <div className={styles.dots}>
          <span />
        </div>
      )}

      <div className={styles.info}>
        <div
          className={classNames(
            styles.step,
            showStartInfo ? styles.open : null
          )}
        >
          <a
            href=""
            className={styles.header}
            onClick={(e) => toggleStepStatus(e, 'start')}
          >
            <p>{t('puntoSalida')}</p>
            <div>
              <p>{points[0].direccion}</p>
              <p>
                {getMunicipalityName(
                  points[0].id_municipio,
                  generalConfig?.ciudad
                )}
                ,{' '}
                {
                  getDepartmentByMunicipality(
                    points[0].id_municipio,
                    generalConfig?.ciudad,
                    generalConfig?.departamento
                  )?.nombre
                }
              </p>
              <Icon icon="arrow" size={15} />
            </div>
          </a>

          <div className={styles.moreInfo}>
            <p>
              {splitField(points[0].descripcion, locale) ??
                `${t('cordenadasSalida')} ${points[0].coordenadas}`}
            </p>
          </div>
        </div>

        {points[1].id_municipio && (
          <div
            className={classNames(
              styles.step,
              showEndInfo ? styles.open : null
            )}
          >
            <a
              href=""
              className={styles.header}
              onClick={(e) => toggleStepStatus(e, 'end')}
            >
              <p>{t('puntoLlegada')}</p>
              <div>
                <p>{points[1].direccion}</p>
                <p>
                  {getMunicipalityName(
                    points[1].id_municipio,
                    generalConfig?.ciudad
                  )}
                  ,{' '}
                  {
                    getDepartmentByMunicipality(
                      points[1].id_municipio,
                      generalConfig?.ciudad,
                      generalConfig?.departamento
                    )?.nombre
                  }
                </p>
                <Icon icon="arrow" size={15} />
              </div>
            </a>

            <div className={styles.moreInfo}>
              <p>
                {points[1].descripcion ??
                  `${t('cordenadaLlegada')} ${points[1].coordenadas}`}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
